import { createAction } from 'redux-actions';

export const setPointBalance = createAction('SET_POINT_BALANCE');